import { SaleOrderDto } from './sale-order.dto';
import {SODto} from './sale-order.dto';
import { GlobalResponseObject } from '@gtpl/shared-models/common-models';


export class AllSaleOrdersResponseModel extends GlobalResponseObject {
    data?: SODto[];

    /**
     * 
     * @param status 
     * @param errorCode 
     * @param internalMessage 
     * @param data /SODto[]
     */
    constructor(status: boolean, errorCode: number, internalMessage: string, data?: SODto[]) {
        super(status, errorCode, internalMessage);
        this.data = data;
    }
}

 